module.exports = __webpack_public_path__ + "img/lupin.bfb5f7d5.svg";